<template>
  <div class="section-container production">
      <div class="main-container">
        <floating></floating>
        <!-- 产品介绍 -->
        <div class="production__recommend">
          <div class="page__title">
            <h2 class="large__title">产品介绍</h2>
            <h4 class="small__title square">PRODUCT INTRODUCTION</h4>
          </div>
          <div class="message" v-show="list.length === 0" style="margin-top: 200px">
            暂无数据
          </div>
          <borrowList :data-list="list" />
          <div style="margin-top: 40px" v-show="list.length !== 0">
            <pagebar
            :count="count"
            :page-size="pageSize"
            :current-page="currentPage"
            @on-page-click="onPageClick"/>
          </div>
        </div>
        <!-- 产品介绍结束 -->
      </div>
    </div>
</template>

<script>
  import Pagebar from '@/components/combo/pagination'
  import BorrowList from '@/components/borrow/list'
  import Floating from '@/components/combo/floating'
  export default {
    components: {
      Pagebar,
      BorrowList,
      Floating
    },
    name: 'Borrow',
    data () {
      return {
        list: [],
        currentPage: 1,
        pageSize: 6,
        count: 0
      }
    },
    created () {
      this.sceneId = this.$route.query.sceneid
      this._fetchData()
    },
    watch: {
      '$store.state.city' () {
        this.currentPage = 1
        if (this.sceneId) {
          this.$router.push('/borrow')
        } else {
          this._fetchData()
        }
      },
      $route (to, from) {
        this.currentPage = 1
        this.sceneId = to.query.sceneid
        this._fetchData()
      }
    },
    methods: {
      _fetchData () {
        let vm = this
        this.$http({
          url: this.sceneId ? '/getProductByScene.jhtml' : '/getProductByCity.jhtml',
          data: {
            cityNo: this.sceneId ? '' : this.$store.state.city.code,
            sceneId: this.sceneId,
            isPage: 'y',
            pageSize: vm.pageSize || 6,
            pageNumber: vm.currentPage || 1
          },
          done (list, page) {
            vm.list = [].concat(list)
            if (vm.sceneId && vm.list.length === 1) {
              vm.$router.replace('/borrow/' + vm.list[0].id)
            }
            vm.count = page.count
            vm.pageSize = page.pageSize
            vm.pageNumber = page.pageNumber
          }
        })
      },
      onPageClick (index) {
        this.currentPage = index
        this._fetchData()
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../stylus/mixin'
  .section-container
    min-width 1180px
    // background-image url(/static/img/borrow-bg.png)
    // background-size cover
    // background-repeat no-repeat
    // background-position center top
  // 版心容器
  .main-container
    margin 0 auto
    width 1180px !important
  // 产品介绍开始
  .production__recommend
    padding 46px 0 76px
  // 产品介绍结束
</style>



// WEBPACK FOOTER //
// borrow.vue?436638dc